module.exports = __webpack_public_path__ + "static/media/radio.1b3e94b3.svg";